import { Component, OnInit, Output, EventEmitter, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit, OnChanges {

  @Output() public generar : EventEmitter<any>;
  @Output() public imprimir : EventEmitter<any>;
  @Output() public descargar : EventEmitter<any>;

  @Input() public  objetoPermisos : Permisos = {
    imprimir : false,
    descargar : false,
    filtros : false
  }

  constructor() {
    this.generar = new EventEmitter();
    this.imprimir = new EventEmitter();
    this.descargar = new EventEmitter();
  }

  ngOnInit() {
  }

  ngOnChanges() {
    this.getObjetoPermisos();
  }

  private async getObjetoPermisos() {
    try {
      await this.objetoPermisos;
    } catch(exception) {
      console.log(exception);
    }
  }

  public onGenerar() {
    this.generar.emit({});
  }

  public onImprimir() {
    this.imprimir.emit({});
  }

  public onDescargar() {
    this.descargar.emit({});
  }

}

interface Permisos {
  imprimir : boolean,
  descargar : boolean,
  filtros : boolean
}